import { Component } from '@angular/core';

@Component({
    selector: 'app-legal',
    standalone: true,
    templateUrl: './legal.component.html',
    styleUrl: './legal.component.css'
})
export class LegalComponent { }
